import React from "react";
import styles from "./styles.module.scss";

// The app's one preloader: a plain ring in the brand blue (no logo).
const Spinner: React.FC = () => {
  return (
    <div className={styles.loaderMainContainer}>
      <div className={styles.loaderContainer}>
        <span className={styles.loader} role="status" aria-label="Loading" />
      </div>
    </div>
  );
};

export default Spinner;
